(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["r69-product-share"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('r69-product-share')) return;

    class R69ProductShare extends HTMLElement {
      connectedCallback() {
        const native = this.querySelector('[data-share-net="native"]');
        if (native && navigator.share) native.hidden = false;

        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-share-net]');
          if (button) this.share(button.getAttribute('data-share-net'));
        });
      }

      /* Share the size the shopper actually picked. Read it from the add-to-cart form rather than
         the address bar: the picker writes ?variant= only after a yieldToMainThread(), while the
         form's hidden input is updated synchronously — and it is the same id the cart would get. */
      get shareUrl() {
        const base = this.dataset.shareUrl;
        const section = this.closest('[id*="ProductInformation-"]');
        const variant = section?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
        return variant ? base + '?variant=' + variant : base;
      }

      share(net) {
        const url = this.shareUrl;
        const title = this.dataset.shareTitle;
        const u = encodeURIComponent(url);
        const t = encodeURIComponent(title);

        if (net === 'native') {
          if (navigator.share) navigator.share({ title: title, text: title, url: url }).catch(() => {});
          return;
        }
        if (net === 'email') {
          window.location.href = 'mailto:?subject=' + t + '&body=' + encodeURIComponent(title + '\n\n' + url);
          return;
        }

        const targets = {
          whatsapp: 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url),
          telegram: 'https://t.me/share/url?url=' + u + '&text=' + t,
          facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + u,
          x: 'https://twitter.com/intent/tweet?url=' + u + '&text=' + t,
        };
        if (targets[net]) window.open(targets[net], '_blank', 'noopener,width=620,height=560');
      }
    }

    customElements.define('r69-product-share', R69ProductShare);
  })();
  } catch(e) { console.error(e); }
})();

})();
